import ReactGA from 'react-ga';

function init() {
  ReactGA.initialize(process.env.REACT_APP_GA_ID);
}

function sendEvent(payload) {
  ReactGA.event(payload);
}

function sendPageview(path) {
  ReactGA.set({ page: path });
  ReactGA.pageview(path);
}

const analytics = {
  init,
  sendEvent,
  sendPageview,
};

export default analytics;
